import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { I18nModule, Product, ProductReference, UrlModule } from "@spartacus/core";
import { slugify } from "../../../../core/services/simple-tools";
import { TOASTER_TYPE } from "../../../../components/toaster/toaster.model";
import { ToasterService } from "../../../../components/toaster/toaster.service";

@Component({
  selector: 'product-replacement',
  standalone: true,
  imports: [CommonModule, I18nModule, RouterModule, UrlModule],
  templateUrl: './product-replacement.component.html',
  styleUrl: './product-replacement.component.scss',
})
export class ProductReplacementComponent {
  @Input() product!: Product;

  slugify = slugify;

  constructor(private toasterService: ToasterService) {}

  getReplacements(): ProductReference[] {
    return this.product.productReferences as unknown as ProductReference[] || [];
  }

  getReplacementsIDs(): string[] {
    if (!this.product?.code) {
      return [];
    }

    const replacementIds = this.getReplacements()
      .flatMap(product => product.target?.code)
      .filter((code): code is string => !!code);

    return [this.product.code, ...replacementIds];
  }

  showNoReplacementToast() {
    this.toasterService.closeALL();

    this.toasterService.init({
      type: TOASTER_TYPE.WARNING,
      content: 'No substitute products were found for the product.',
    });
  }
}
